export default __webpack_public_path__ + "static/numpad-full-97a81300a37c940e437167c26d1b26c6.jpeg";